import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=6359102a&"
import script from "./dropdown-item.vue?vue&type=script&lang=js&"
export * from "./dropdown-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6359102a')) {
      api.createRecord('6359102a', component.options)
    } else {
      api.reload('6359102a', component.options)
    }
    module.hot.accept("./dropdown-item.vue?vue&type=template&id=6359102a&", function () {
      api.rerender('6359102a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/dropdown/src/dropdown-item.vue"
export default component.exports